:host {
  display: block;
}

.well {
  padding: var(--s0);
}

.well * + * {
  margin-top: var(--s-2);
}

.well.gray {
  background-color: var(--color-off-white);
}
.well.blue {
  color: white;
  background-color: var(--color-cwru-blue);
}
.well.blue > * {
  color: white;
}
